import React, { useEffect } from 'react';

// Components
import CertificadoEntregaComunicacaoEletronica from '../../FichaInfracao/components/CertificadoEntregaComunicacaoEletronica';

 
export default function ItemComprovanteEnvioEmail({ infracao, onReady }) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { onReady(); }, []);

    const notificacao = infracao.notificacoesEmails?.find(x => x.status === "Confirmado");
    if (!notificacao) return null;

    return (
        <CertificadoEntregaComunicacaoEletronica
            dadosExtracao={notificacao}
            dadosInfracao={infracao}
            impressaoDividaAtivaPDF
        />
    );
}
